const CONTROL_HEIGHT = 40;

export default (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
  toolbar: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
  },
  clientSelect: {
    minWidth: 180,
    '& .MuiInputBase-root': {
      height: CONTROL_HEIGHT,
    },
  },
  searchField: {
    flex: '1 1 240px',
    maxWidth: 360,
    '& .MuiInputBase-root': {
      height: CONTROL_HEIGHT,
    },
  },
  grow: {
    flexGrow: 1,
  },
});
